import type { ReactNode } from 'react';
import { Column } from '@tempmee/react';

interface INoScreenProps {
  children: ReactNode;
}

/**
 * Full-height page container for surfaces that intentionally opt out of the DS `<Screen>`
 * card — the content floats on the subdued page background instead (e.g. the Schedule
 * list view, which previously needed a global.scss `!important` hack to strip the Screen
 * body card). Named rather than an inline `<Column>` so it's easy to find when `<Screen>`
 * usage is audited/removed later.
 */
export const NoScreen = ({ children }: INoScreenProps) => (
  <Column className="bg-background-subdued w-full flex-1 items-center gap-4 px-4 pt-10 pb-4">
    {children}
  </Column>
);
